module.exports = __webpack_public_path__ + "img/works_jeju_y_btm.f33fa6c7.jpg";